import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#FD7762", // Brand accent color
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#FFDDD9", // Pastel for lighter UI
      contrastText: "#1A1A1A", // Works on light background
    },
    text: {
      primary: "#515151",
      secondary: "#1A1A1A",
    },
    background: {
      default: "#ffffff",
    },
  },
  typography: {
    fontFamily: "Inter, Poppins, sans-serif",
    h1: {
      fontWeight: 700,
      fontSize: "2.5rem",
    },
    h2: {
      fontWeight: 700,
      fontSize: "2rem",
    },
    h3: {
      fontWeight: 600,
      fontSize: "1.75rem",
    },
    body1: {
      fontSize: "1rem",
    },
    body2: {
      fontSize: "0.875rem",
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          padding: "12px 24px",
          fontWeight: 600,
          transition: "all 0.3s",
        },
        containedPrimary: {
          backgroundColor: "#FD7762",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#fd7762cc",
          },
        },
        containedSecondary: {
          backgroundColor: "#FFDDD9",
          color: "#1A1A1A",
          "&:hover": {
            backgroundColor: "#f8c4bd",
          },
        },
        outlinedSecondary: {
          borderColor: "#FFDDD9",
          color: "#FD7762",
          "&:hover": {
            backgroundColor: "#fff5f4",
            borderColor: "#FD7762",
          },
        },
        textSecondary: {
          color: "#FD7762",
          "&:hover": {
            backgroundColor: "#fff5f4",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
          transition: "all 0.3s",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 500,
        },
      },
    },
  },
});

export default theme;
